import React from 'react';
import { Redirect, Router, Switch } from 'react-router-dom'
import Route from '../home/components/routes/route-wrapper';
import './layout.scss'
import SideBar from './sideBar-v3/sideBar'
import getRoutes from '../routes/routes'
import Header from '../home/components/common/header/header-component'
import RoutePaths from '../../src/home/components/routes/routes-path'
import SessionCache from '../home/components/routes/session-cache';
import LayoutShared from '../home/components/common/layout-shared/layout-shared';
import Loading from '../home/components/common/loading/loading';
import CommonUtils from '../home/utility/common-utilities';
import { Constants } from '../home/constants/constants';
import { getImageSource } from '../home/utility/image-source';
import { ImageConstants } from '../home/constants/constants';
import CommonApi from '../home/apis/common';


export default class Layout extends React.Component {


    state = {
        showLayoutBar: true,
        showSubjectSelectionScreen: false,
        isOnline: CommonUtils.isOnline(),
        mannualOffline: false,
    }

    constructor(props) {
        super(props)
        let user = SessionCache.getUser()
        console.log(user)
        this.routes = getRoutes(user)
        console.log(this.routes)
        LayoutShared.setLayout(this)
        // this.updateOnlineStatus = this.updateOnlineStatus.bind(this);
        // this.updateOnlineStatus()

    }

    componentDidMount() {
        console.log('layout component did mount')
        if (CommonUtils.isOnline()) {
            this.forceOffline(false)
        }
    }



    componentWillUnmount() {
        // Remove event listeners when the component unmounts
        // window.removeEventListener('online', this.updateOnlineStatus);
        // window.removeEventListener('offline', this.updateOnlineStatus);
    }

    updateOnlineStatus = (isOnline) => {
        // Update the state with the current online status
        console.log('layout status')

        if (!isOnline) {
            alert('You are offline. Please check your internet connection.');
            this.forceOffline(true)
        } else {
            alert('You are back online.');
            this.forceOffline(false)
        }
    }




    registerRoutes = () => {
        return (this.routes.map(route => {
            return route.subMenus ? route.subMenus.map(s => <Route exact path={s.path} component={s.component} />) :
                route.component ? <Route exact path={route.path} component={route.component} /> : ""

        }))
    }




    showHideLayoutBar = (value) => {

        this.setState({ showLayoutBar: value }, () => {
            // console.log(this.state.showLayoutBar)
        })
    }

    forceOffline = (value, homeworkItem = '') => {
        // console.log(value)
        // this.setState({ mannualOffline: value, isReload: false });

        if (value) {
            this.goOffline(homeworkItem)
        } else {
            this.goOnline()
        }

    };

    goOffline = (homeworkItem) => {
        CommonUtils.setOffline();
        this.setState({ homeworkItem })
        // this.forceUpdate(); // if UI depends on it
    };

    goOnline = () => {
        CommonUtils.setOnline();
        this.setState({ homeworkItem: '' })
        // this.forceUpdate();
    };

    showSubjectSelectionScreen() {
        this.setState({ showSubjectSelectionScreen: true })
    }

    render() {
        console.log('layout render', this.state.isOnline, this.state.mannualOffline, CommonUtils.isOnline())
        return (
            <div className='layout'>
                {
                    !this.state.isReload ?
                        <>
                            <Header delegate={this} showHideHeader={this.state.showLayoutBar} />
                            <div className='sideBar' style={{ display: `${this.state.showLayoutBar && !Constants.ELECTRON_BUILD ? "block" : "none"}` }}>
                                <SideBar routes={this.routes} {...this.props} />
                            </div>
                            <div id='main-component' className={`main-component 
                            ${this.state.hideSideBar ? "change-main-component-margin" : ""}
                ${this.state.showLayoutBar ? "main-component" : 'change-main-component-margin-for-side-bar-hide'} 
                ${this.state.showLayoutBar ? '' : 'overflow-hidden'}
                ${Constants.ELECTRON_BUILD ? 'no-margin-left' : ''}`}>
                                <Switch>
                                    {this.registerRoutes()}
                                    <Route exact path='*'>
                                        <Redirect to={Constants.ELECTRON_BUILD ? RoutePaths.DASHBOARD : RoutePaths.DASHBOARD} />
                                    </Route>
                                </Switch>
                            </div>
                        </>
                        :
                        // <Loading /> // Here only we have to add the Screen - to Show no internet
                        <Route exact path='*'>
                            <Redirect to={RoutePaths.LOGIN} />
                        </Route>
                }
            </div >
        )
    }
}